import { render, staticRenderFns } from "./AnularPedidoModal.vue?vue&type=template&id=e2dd5cb8"
import script from "./AnularPedidoModal.vue?vue&type=script&lang=js"
export * from "./AnularPedidoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports